import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store/store'
import i18n from './i18n/'
import './plugins/veeValidate'

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey:  process.env.VUE_APP_RECAPTCHA_TOKEN })

Vue.config.productionTip = false

import formatDateTime from '@/mixins/formatDateTime'
Vue.mixin(formatDateTime)


new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
